angular.module('impactx.dialog').service('DialogPanelService', [
    '$mdPanel',
    '$q',
    '$rootScope',
    DialogPanelService]);

function DialogPanelService($mdPanel, $q, $rootScope) {
    var self = this;
    var panelRef, mainViewElement, panelPosition, panelAnimation, resizeWatcher, defer, transferData, locals;

    function setPanelWidth(config) {
        var panelWrapper = angular.element(config.panelClass || '.' + 'dialog-panel-default');
        if (angular.isElement(panelWrapper)) {
            panelWrapper.css('width', mainViewElement[0].getBoundingClientRect().width);
        }
    }

    function resizePanel(config) {
        setPanelWidth(config);

        resizeWatcher = $rootScope.$watch(function () {
            return mainViewElement[0].getBoundingClientRect().width;
        }, function () {
            setPanelWidth(config);
        });
    }

    function setupPanelConfig() {
        transferData = undefined;
        panelRef = $q.defer();
        mainViewElement = angular.element('#ix-main-view');
        var mainViewBottom = mainViewElement[0].getBoundingClientRect().bottom;
        var mainViewLeft = mainViewElement[0].getBoundingClientRect().left;
        mainViewElement.addClass('relative-position');

        panelPosition = $mdPanel.newPanelPosition().absolute();
        panelAnimation = $mdPanel.newPanelAnimation()
            .openFrom({top: mainViewBottom, left: mainViewLeft})
            .duration(300)
            .closeTo({top: mainViewBottom, left: mainViewLeft})
            .withAnimation($mdPanel.animation.SLIDE);
    }

    self.open = function (config) {
        if (config) {
            setupPanelConfig();
            defer = $q.defer();
            locals = config.locals || {};

            var panelConfig = {
                attachTo: mainViewElement,
                controller: 'DialogPanelCtrl',
                controllerAs: 'ctrl',
                locals: {
                    config: config
                },
                position: panelPosition,
                animation: panelAnimation,
                panelClass: 'dialog-panel-default',
                event: config.event || undefined,
                templateUrl: 'shared/dialog/templates/dialog-panel-container.html',
                clickOutsideToClose: config.clickOutsideToClose || true,
                escapeToClose: config.escapeToClose || true,
                focusOnOpen: config.focusOnOpen || true,
                onDomAdded: function () {
                    resizePanel(config);
                },
                onRemoving: function () {
                    mainViewElement.removeClass('relative-position');
                    resizeWatcher();
                }
            };

            $mdPanel.open(panelConfig).then(function (result) {
                panelRef = result;
            });

            return defer.promise;
        }
        else {
            console.log('no config for dialog service provided!')
        }
    };

    self.closePanel = function () {
        defer.resolve(transferData);
        transferData = {};
        panelRef.close().then(function () {
            panelRef.destroy();
        });
    };

    self.setTransferData = function (data) {
        transferData = data ? data : {};
    };

    self.readLocals = function () {
        var result = locals;
        locals = {};
        return result;
    };

    return {
        open: self.open,
        closePanel: self.closePanel,
        setTransferData: self.setTransferData,
        readLocals: self.readLocals
    };
}